<template>
    <v-card>
        <v-card-subtitle>Pending settlements</v-card-subtitle>
        <v-divider />
        <v-card-text>
            <v-card
                class="mb-4"
                v-for="item in sortedList"
                v-bind:key="item.id"
            >
                <v-card-title>
                    {{ new Date(item.date) | date('dd-MMM-yyyy') }}
                </v-card-title>
                <v-divider />
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        small
                        tile
                        color="primary"
                        v-on:click="setDate(item)"
                        v-bind:loading="$store.state.app.loading"
                        >Choose</v-btn
                    >
                    <v-btn
                        small
                        tile
                        color="success"
                        v-if="isOperator"
                        v-on:click="setSettled(item)"
                        v-bind:loading="$store.state.app.loading"
                        >Mark settled</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-card-text>
    </v-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    props: {
        pendingSettlements: {
            type: Array,
            required: true
        }
    },
    computed: {
        ...mapGetters({
            isOperator: 'auth/isOperator'
        }),
        sortedList() {
            let list = [...this.pendingSettlements];
            return list.sort((a, b) => {
                if (a.date < b.date) return -1;
                if (a.date > b.date) return 1;
                return 0;
            });
        }
    },
    methods: {
        setDate(settlement) {
            this.$emit('request-set-date', settlement.date);
        },
        setSettled(settlement) {
            this.$emit('request-set-settled', settlement, true);
        }
    }
};
</script>
